// extracted by mini-css-extract-plugin
module.exports = {"Protection":"Protection_Protection__7XNkn"};